import client from "../client";
import { patchSubscriptionConfig } from "./patchSubscriptionConfig";
import { patchSubscriptionPayload } from "./types";

const patchSubscription = (data?: patchSubscriptionPayload) =>
  client({
    ...patchSubscriptionConfig({
      authorization: data.authorization,
      xForwardedFor: data.xForwardedFor,
    }),
    data: { subscriptionId: data.subscriptionId },
  });

export default { patchSubscription };
